import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Modal, Form } from "react-bootstrap";
import { ButtonComponent, AnchorComponent } from "../elements";
import axios from "axios";
import Select from 'react-select';
import { encode } from 'base-64';
import { API_URL, APP_PREFIX_PATH } from "../../constant/constant";
import PaginationComponent from "../PaginationComponent";
import { Row, Col } from "react-bootstrap";
import LabelFieldComponent from "../fields/LabelFieldComponent";
import { Link } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import categoryImage from '../../assets/img/category.webp';
import './AppointmentTable.css';
// import CheckIcon from '@mui/icons-material/Check';
// import ClearIcon from '@mui/icons-material/Clear';


export default function ConsultationTableComponent({ thead, tbody }) {
    const { t } = useContext(TranslatorContext);
    const [AppointmentDetails, setAppointmentDetails] = useState([]);



    const [Error, setError] = useState('');
    const [DeleteId, setDeleteId] = useState('');

    const [userData, setUserData] = useState("");
    const [editModal, setEditModal] = useState(false);
    const [AddModal, setAddModal] = useState(false);
    const [alertModal, setAlertModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);


    const [AddService, setAddService] = useState('');
    const [addImage, setaddImage] = useState('');
    const [EditService, setEditService] = useState('');
    const [EditImage, setEditImage] = useState('');
    const [EditId, setEditId] = useState('');

    const [AddServiceError, setAddServiceError] = useState('');
    const [addImageError, setaddImageError] = useState('');
    const [EditServiceError, setEditServiceError] = useState('');
    const [EditImageError, setEditImageError] = useState('');

    const [searchTerm, setSearchTerm] = useState("");
    const entriesPerPage = 5;

    const indexOfLastEntry = currentPage * entriesPerPage;
    const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;


    const filteredUsers = AppointmentDetails.filter((user) => {
        const lowercasedTerm = searchTerm.toLowerCase();
        return (
            user.user_name?.toLowerCase().includes(lowercasedTerm) ||
            user.clinic_name?.toLowerCase().includes(lowercasedTerm) ||
            user.doctor_name?.toLowerCase().includes(lowercasedTerm) ||
            user.service_name?.toLowerCase().includes(lowercasedTerm) ||
            user.createtime?.toLowerCase().includes(lowercasedTerm)
        );
    });


    const currentUsers = filteredUsers.slice(indexOfFirstEntry, indexOfLastEntry);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    const fetchAppointmentDetails = () => {
        const user_type = localStorage.getItem('user_type');

        axios.post(API_URL + "/fetch_consultation_details", { user_type })
            .then((response) => {
                setAppointmentDetails(response.data.fetchConsultation_arr.reverse() || []);
                // console.log('sdf', response.data.fetchAppointment_arr)

            })
            .catch((error) => {
                console.error('Error fetching user details:', error);
            });
    };









    useEffect(() => {
        fetchAppointmentDetails();
    }, []);

    const handleUserAction = (action, service_id, experience_qualification) => {

        if (action === 'edit') {
            setEditId(service_id);
            setEditService(experience_qualification);

        }
        else if (action === 'delete') {
            setAlertModal(true);
            setDeleteId(service_id);
        }
    }

    const DoctorDelete = () => {
        // console.log('sdf', );

        axios.post(API_URL + '/delete_service', { service_id: DeleteId }).then((res) => {

            if (res.data.success) {
                // fetchAppointmentDetails();
            }


        }).catch((error) => {
            console.log(error);

        })
    }

    const handleEditService = () => {

        let hasError = false;
        if (!EditService || EditService.trim() == '') {
            setEditServiceError('Please enter service name');
            hasError = true;
        }




        if (hasError) {
            return;
        }




        const formData = new FormData();
        formData.append('service_id', EditId);
        formData.append('service_name', EditService);
        formData.append('service_image', EditImage);


        axios.post(API_URL + '/edit_service', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }).then(response => {
            if (response.data.key === 'exist') {
                setError('Service Already Exist');
                return;
            }
            // fetchAppointmentDetails();
            setEditModal(false);



        })
            .catch(error => {

                console.error('Error updating clinic:', error);
            });
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };


    // add doctor 
    const handleAddService = () => {

        let hasError = false;
        if (!AddService || AddService.trim() == '') {
            setAddServiceError('Please enter service name');
            hasError = true;
        }

        if (!addImage) {
            setaddImageError('Please upload image')
            hasError = true;
        }


        if (hasError) {
            return;
        }




        const formData = new FormData();
        formData.append('service_name', AddService);

        formData.append('service_image', addImage);


        axios.post(API_URL + '/add_service', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }).then(response => {
            if (response.data.key === 'exist') {
                setError('Sevrice Already Exist');
                return;
            }
            if (response.data.success) {
                fetchAppointmentDetails();
                setAddModal(false);
            }
        })
            .catch(error => {

                console.error('Error updating clinic:', error);
            });
    };

    return (
        <>

            <Row xs={1} sm={2} xl={4} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Col>
                    <LabelFieldComponent
                        type="search"
                        // label={t('search_by')}
                        icon="Search"
                        placeholder={`${t('search_here')}`}
                        labelDir="label-col"
                        fieldSize="mb-4 w-100 h-md"
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                </Col>

            </Row>




            <div className="mc-table-responsive">
                <table className="mc-table">
                    <thead className="mc-table-head primary">
                        <tr>
                            <th>
                                <div className="mc-table-check">
                                    <p>{t("sno")}</p>
                                </div>
                            </th>
                            <th>{t("actions")}</th>

                            <th>{t("user_name")}</th>
                            <th>{t("clinic_name")}</th>
                            <th>{t("doctor_name")}</th>
                            <th>{t("service_name")}</th>
                            <th>{t("consultation_date_time")}</th>
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                        {currentUsers?.map((item, index) => (
                            <tr key={index}>
                                <td title="id">
                                    <div className="mc-table-check">
                                        <p>{indexOfFirstEntry + index + 1}</p>
                                    </div>
                                </td>
                                <td>
                                    <div className="mc-table-action">

                                        <AnchorComponent to={`${APP_PREFIX_PATH}/view-consultation/${encode(item.consultation_id)}`} title="View" className="material-icons view">visibility</AnchorComponent>
                                        {/* <AnchorComponent title="check" className="material-icons check" style={{ background: '#19d90d', color: '#fff' }}> check</AnchorComponent> */}





                                    </div>
                                </td>

                                < td >
                                    <span>{item.user_name || 'NA'}</span>
                                </td>
                                <td>{item.clinic_name || 'NA'}</td>
                                <td>{item.assigned_doctor_name || item.doctor_name || 'NA'}</td>
                                <td>{item.service_name || 'NA'}</td>
                                <td>{item.createtime || 'NA'}</td>

                            </tr>
                        ))}
                    </tbody>
                </table >


                <PaginationComponent
                    totalEntries={filteredUsers.length}
                    entriesPerPage={entriesPerPage}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />

                <Modal show={editModal} onHide={() => setEditModal(false)}>
                    <div className="mc-user-modal">
                        <img
                            src={categoryImage}
                            alt="Profile"
                        />
                        <h4>{userData?.name}</h4>
                        <p>{userData?.email}</p>
                        <Form.Group className="form-group mb-4 ml-2">
                            <Form.Label>{t('service_name')}</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder={t('enter_service_name')}
                                value={EditService}
                                onChange={(e) => { setEditService(e.target.value); setEditServiceError(''); setError('') }}
                            />
                            <p style={{ color: 'red' }}>{EditServiceError}</p>
                        </Form.Group>
                        <Form.Group className="form-group mb-4 ml-2">
                            <Form.Label>{t('image')}</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    setEditImage(file);
                                    setEditImageError('')
                                }}
                            />
                            <p style={{ color: 'red' }}>{EditImageError}</p>
                        </Form.Group>

                        <p style={{ color: 'red' }}>{Error}</p>
                        <Modal.Footer>
                            <ButtonComponent type="button" className="btn btn-secondary" onClick={() => { setEditModal(false); setEditService(''); setEditServiceError(''); setEditImageError(''); setError('') }}>
                                {t('close_popup')}
                            </ButtonComponent>
                            <ButtonComponent type="button" className="btn btn-success" onClick={handleEditService}>
                                {t('save_changes')}
                            </ButtonComponent>
                        </Modal.Footer>
                    </div>
                </Modal >

                <Modal show={AddModal} onHide={() => setAddModal(false)}>
                    <div className="mc-user-modal">
                        <img
                            src={categoryImage}
                            alt="Profile"
                        />
                        <h4>{userData?.name}</h4>
                        <p>{userData?.email}</p>
                        <Form.Group className="form-group mb-4 ml-2">
                            <Form.Label>{t('service_name')}</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder={t('enter_service_name')}
                                value={AddService}
                                onChange={(e) => { setAddService(e.target.value); setAddServiceError(''); setError('') }}
                            />
                            <p style={{ color: 'red' }}>{AddServiceError}</p>
                        </Form.Group>
                        <Form.Group className="form-group mb-4 ml-2">
                            <Form.Label>{t('image')}</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    setaddImage(file);
                                    setaddImageError('')
                                }}
                            />
                            <p style={{ color: 'red' }}>{addImageError}</p>
                        </Form.Group>
                        <p style={{ color: 'red' }}>{Error}</p>

                        <Modal.Footer>
                            <ButtonComponent type="button" className="btn btn-secondary" onClick={() => { setAddModal(false); setAddService(''); setaddImageError(''); setAddServiceError(''); setError('') }}>
                                {t('close_popup')}
                            </ButtonComponent>
                            <ButtonComponent type="button" className="btn btn-success" onClick={handleAddService}>
                                {t('save_changes')}
                            </ButtonComponent>
                        </Modal.Footer>
                    </div>
                </Modal >

                <Modal show={alertModal} onHide={() => setAlertModal(false)}>
                    <div className="mc-alert-modal">
                        <i className="material-icons">new_releases</i>
                        <h3>are your sure!</h3>
                        <p>Want to delete this service?</p>
                        <Modal.Footer>
                            <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setAlertModal(false)}>{t('close')}</ButtonComponent>
                            <ButtonComponent type="button" className="btn btn-danger" onClick={() => { setAlertModal(false); DoctorDelete(); }}>{t('delete')}</ButtonComponent>
                        </Modal.Footer>
                    </div>
                </Modal >
            </div >
        </>
    );
}
